import { makeStyles } from "@material-ui/styles";

const drawerWidth = 72;

const layoutStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		height: "100%",
		zIndex: 1,
		overflow: "hidden",
		background: "linear-gradient(180deg, #202D43 0%, #0D121C 100%)",
		// Overrides for fixing the issue with nested themes.
		color: theme.palette.gameMode.primary,
		"& h6": {
			color: theme.palette.gameMode.primary
		}
	},
	appFrame: {
		position: "relative",
		display: "flex",
		width: "100%",
		height: "100vh",
		backgroundColor: theme.palette.menu.backgroundColor,
		overflow: "auto"
	},
	content: {
		width: "100%",
		height: "100%",
		[theme.breakpoints.only("xs")]: {
			padding: theme.spacing(1)
		},
		[theme.breakpoints.up("sm")]: {
			padding: theme.spacing(6),
			minHeight: "650px"
		},
		overflowY: "auto",
		background: theme.palette.container.backgroundColor,
		position: "relative"
	},
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
		whiteSpace: "nowrap",
		borderRight: `1px solid ${theme.palette.border.primary}`
	},
	drawerOpen: {
		background: "transparent",
		width: drawerWidth,
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
		[theme.breakpoints.only("sm")]: {
			overflowX: "hidden",
			paddingRight: 1
		}
	},
	drawerClose: {
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen
		}),
		overflowX: "hidden",
		width: theme.spacing(7) + 1,
		[theme.breakpoints.up("sm")]: {
			width: theme.spacing(9) + 1
		}
	},
	navMenu: {
		"& :hover": {
			backgroundColor: theme.palette.menu.item.active.backgroundColor
		}
	},
	navItem: {
		justifyContent: "center",
		height: 72
	},
	active: {
		backgroundColor: theme.palette.menu.item.active.backgroundColor,
		borderRight: `1px solid ${theme.palette.gameMode.primary}`
	},
	icon: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		color: theme.palette.gameMode.primary,
		"& span": {
			width: "auto",
			height: "auto"
		},
		"& .MuiAvatar-root": {
			width: theme.spacing(3),
			height: theme.spacing(3),
			backgroundColor: theme.palette.gameMode.primary,
			fontSize: theme.spacing(1.5),
			fontWeight: "bold",
			border: "1px solid #fff",
			color: theme.palette.menu.backgroundColor,
			"& :hover": {
				backgroundColor: theme.palette.gameMode.primary
			}
		}
	},
	"@media (prefers-reduced-motion: reduce)": {
		drawerOpen: {
			transition: "none"
		},
		drawerClose: {
			transition: "none"
		}
	},
	mobileDrawer: {
		backgroundColor: theme.palette.menu.backgroundColor
	},
	mobileDrawerNoBorder: {
		borderRight: "none"
	},
	logoButton: {
		backgroundColor: "transparent",
		minHeight: "70px",
		"&:hover": {
			backgroundColor: "transparent",
			boxShadow: "none"
		},
		"&.Mui-disabled": {
			backgroundColor: "transparent"
		}
	},
	mobileIconButton: {
		position: "absolute",
		left: -2,
		top: 10,
		padding: 0,
		backgroundColor: "transparent",
		"&:hover": {
			backgroundColor: "transparent",
			boxShadow: "none"
		}
	}
}));

export default layoutStyles;
